"use client";

import Image from "next/image";

interface HeroSectionProps {
  tenant: {
    name: string;
    logoUrl?: string;
    primaryColor: string;
  };
  title?: string | null;
  description?: string | null;
}

/**
 * Hero Section Component for Tenant Pages
 *
 * Displays a hero banner with the tenant's logo, a customizable title,
 * and description. Uses tenant colors for styling.
 */
export function HeroSection({ tenant, title, description }: HeroSectionProps) {
  const displayTitle = title || tenant.name;
  const displayDescription = description || "Discover our interactive scavenger hunts and earn digital rewards";

  return (
    <div className="text-center mb-12">
      {tenant.logoUrl && (
        <div className="relative h-16 w-48 mx-auto mb-6">
          <Image
            src={tenant.logoUrl}
            alt={tenant.name}
            fill
            className="object-contain"
            unoptimized
          />
        </div>
      )}
      <h1
        className="text-4xl font-bold mb-6"
        style={{ color: 'var(--theme-text, #111827)' }}
      >
        {displayTitle}
      </h1>
      <p
        className="text-xl mb-8"
        style={{ color: 'var(--theme-text, #6B7280)', opacity: 0.8 }}
      >
        {displayDescription}
      </p>
    </div>
  );
}
